module.exports = __webpack_public_path__ + "static/suitcases-af3648dc14d45d5558f7d141e51413d8.jpeg";